import React from 'react';
import { Row } from 'react-bootstrap';
import { useRequestedAbsenceQuery } from '../../../../../__generated__/graphql';
import ServerError from '../../../../../../../components/ServerError';
import Skeleton from 'react-loading-skeleton';
import Detail from '../../../../AbsenceApprovalRequestToMe/Detail';
import OverlappingAbsences from '../../../../AbsenceApprovalRequestToMe/OverlappingAbsences';
import SoftBadge from '../../../../../components/SoftBadge';

type Props = {
  absenceId: string;
};

export const AbsenceDetails: React.FC<Props> = ({ absenceId }) => {
  const { data, loading, error } = useRequestedAbsenceQuery({
    variables: { id: absenceId },
  });

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return (
      <Row className="justify-content-center">
        <SoftBadge variant="danger">{error.message}</SoftBadge>
      </Row>
    );
  }

  const absence = data?.absence;

  if (!absence) {
    return <ServerError />;
  }

  const overlappingAbsences = absence.overlappingAbsences;

  return (
    <Row className="justify-content-center">
      <Detail absence={absence} hideApprovalPath />
      {overlappingAbsences && (
        <OverlappingAbsences absences={overlappingAbsences} />
      )}
    </Row>
  );
};

export const Loading: React.FC = () => {
  return (
    <div>
      <Skeleton height={80} />
      <Skeleton height={80} />
      <Skeleton height={80} />
    </div>
  );
};
